import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelRadio as _vModelRadio, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row px-2 my-2"
}
const _hoisted_2 = {
  key: 0,
  class: "col-12 col-lg-10"
}
const _hoisted_3 = { class: "w-100" }
const _hoisted_4 = { class: "form-check custom-checkbox mb-2" }
const _hoisted_5 = ["id", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "me-1" }
const _hoisted_8 = {
  key: 0,
  class: "card pt-2 px-3 my-2"
}
const _hoisted_9 = { class: "form-check custom-checkbox mb-2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "CopyFromTransferringHospice"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Copy obtained from transferring Hospice")
], -1 /* HOISTED */)
const _hoisted_11 = {
  key: 0,
  class: "row g-0"
}
const _hoisted_12 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "completed-by" }, " Completed By ", -1 /* HOISTED */)
const _hoisted_14 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_15 = { for: "completed-date" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Completed Date ")
const _hoisted_17 = {
  key: 0,
  class: "fa fa-exclamation-triangle text-danger"
}
const _hoisted_18 = {
  else: "",
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary ms-1" }, null, -1 /* HOISTED */)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "input-group date datepickerInput" }
const _hoisted_22 = ["value", "on-change", "disabled"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_24 = {
  key: 1,
  class: "row px-2 my-2"
}
const _hoisted_25 = {
  key: 0,
  class: "col-12 offset-lg-1 col-lg-10"
}
const _hoisted_26 = { class: "w-100" }
const _hoisted_27 = { class: "form-check custom-checkbox form-check-inline mb-2" }
const _hoisted_28 = ["id", "value"]
const _hoisted_29 = ["for"]
const _hoisted_30 = { class: "me-1" }
const _hoisted_31 = {
  key: 0,
  class: "card py-2 px-3 my-2 row"
}
const _hoisted_32 = { class: "form-check custom-radio form-check-inline" }
const _hoisted_33 = ["id", "value"]
const _hoisted_34 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Referral Readiness",
    "application-id": _ctx.referral?.application
  }, {
    content: _withCtx(() => [
      (!_ctx.isApplicationPalliative)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.referral && _ctx.ReferralReadiness.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ReferralReadiness, (readiness) => {
                    return (_openBlock(), _createElementBlock("section", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: `ReferralReadiness${readiness.value}`,
                          class: "form-check-input",
                          value: readiness.value,
                          name: "referral-readiness",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.referralReadiness) = $event))
                        }, null, 8 /* PROPS */, _hoisted_5), [
                          [_vModelCheckbox, _ctx.referral.referralReadiness]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `ReferralReadiness${readiness.value}`
                        }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(readiness.name), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_6)
                      ]),
                      (_ctx.f2fValue === readiness.value && _ctx.isF2fVisitObtained)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: "CopyFromTransferringHospice",
                                class: "form-check-input",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.isCopyObtained) = $event))
                              }, null, 512 /* NEED_PATCH */), [
                                [_vModelCheckbox, _ctx.referral.isCopyObtained]
                              ]),
                              _hoisted_10
                            ]),
                            (!_ctx.referral.isCopyObtained)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _hoisted_13,
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-control",
                                      type: "text",
                                      name: "completed-by",
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.completedBy) = $event))
                                    }, null, 512 /* NEED_PATCH */), [
                                      [_vModelText, _ctx.referral.completedBy]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("label", _hoisted_15, [
                                      _hoisted_16,
                                      (!_ctx.referral.referralDate)
                                        ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_17, null, 512 /* NEED_PATCH */)), [
                                            [_directive_tooltip, { title: 'Please enter the referral date.' }]
                                          ])
                                        : _createCommentVNode("v-if", true),
                                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_18, _hoisted_20)), [
                                        [_directive_custom_popover, {
                                                        content: `A face-to-face visit may not be done more than 30 days
                                                prior to admission. If beyond 30 days, a new face-to-face should be
                                                completed.`,
                                                        className: 'info-popup'
                                                    }]
                                      ])
                                    ]),
                                    _createVNode(_component_DatePicker, {
                                      options: _ctx.datePickerOptions,
                                      getDate: _ctx.completedDateChanged
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_21, [
                                          _createElementVNode("input", {
                                            name: "completedDate",
                                            type: "text",
                                            class: "form-control",
                                            placeholder: "MM/DD/YYYY",
                                            value: _ctx.formatDateInput(_ctx.referral.completedDate),
                                            "on-change": 
                                                            (e) =>
                                                                _ctx.completedDateChanged(e.target.value, e.target.name)
                                                        ,
                                            autocomplete: "off",
                                            disabled: !_ctx.referral?.referralDate
                                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22),
                                          _hoisted_23
                                        ])
                                      ]),
                                      _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["options", "getDate"])
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_24, [
            (_ctx.referral && _ctx.PalliativeReferralReadiness.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PalliativeReferralReadiness, (readiness) => {
                    return (_openBlock(), _createElementBlock("section", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: `ReferralReadiness${readiness.name}`,
                          class: "form-check-input",
                          value: readiness.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.palliativeReferralReadiness) = $event))
                        }, null, 8 /* PROPS */, _hoisted_28), [
                          [_vModelCheckbox, _ctx.referral.palliativeReferralReadiness]
                        ]),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: `ReferralReadiness${readiness.name}`
                        }, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString(readiness.name), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_29)
                      ]),
                      (_ctx.orderReceivedValue == readiness.value && _ctx.isOrderReceived)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CareOrderOptions, (careOrder) => {
                              return (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "radio",
                                  id: `careOrder${careOrder.value}`,
                                  name: "care-order",
                                  class: "form-check-input",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.palliativeCareOrderOptions) = $event)),
                                  value: careOrder.value
                                }, null, 8 /* PROPS */, _hoisted_33), [
                                  [_vModelRadio, _ctx.referral.palliativeCareOrderOptions]
                                ]),
                                _createElementVNode("label", {
                                  class: "form-check-label",
                                  for: `careOrder${careOrder.value}`
                                }, _toDisplayString(careOrder.name), 9 /* TEXT, PROPS */, _hoisted_34)
                              ]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              : _createCommentVNode("v-if", true)
          ]))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}